import ARROW_DOWN from "../../assets/images/arrow-down.png";
import { useMemo, useRef } from "react";
import { useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import { formatIndianNumber } from "../../_helpers/formatUtils";

interface FlightPriceProps {
  route: any;
  sortedPriceList: any;
  openFlightRate: boolean;
  routeIndex: number;
  setOpenFlightRate: (openFlightRate: boolean) => void;
  priceDetails: any;
  handleRadioButtonChange: (id: string) => void;
  handleBookNowClick: (priceDetails: any, route: any) => void;
  handleSelectFlight?: (
    priceDetails: any,
    route: any,
    type: string,
    index: number
  ) => void;
  type?: string;
  index?: number;
  isSelected?: boolean;
  fareRulesLoading: boolean;
  fareRule: any;
  getFareRules: (Fare_Id: string, Flight_Key: string) => void;
}

const FlightPrice = ({
  sortedPriceList,
  openFlightRate,
  priceDetails,
  routeIndex,
  route,
  handleRadioButtonChange,
  setOpenFlightRate,
  handleBookNowClick,
  handleSelectFlight,
  type,
  index,
  isSelected,
  fareRule,
  fareRulesLoading,
  getFareRules,
}: FlightPriceProps) => {
  const flightSearchDetails = useAppSelector(
    (state) => state.home.flightSearchDetails
  );

  const { ADULT, CHILD, INFANT } = flightSearchDetails;

  const cancellationCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.CancellationCharges) ||
    [];
  const rescheduleCharges =
    (priceDetails?.FareDetails[0] &&
      priceDetails?.FareDetails[0]?.RescheduleCharges) ||
    [];

  return (
    <div className="route-price-right">
      <div
        className="modal fade"
        id={`farerulepopup_${routeIndex}`}
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="edit-profile"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: 991 }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title fs-5" id="edit-profile">
                Fare Rule Information
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body travel-form-detail">
              <Loading loading={fareRulesLoading} />
              {cancellationCharges?.length <= 0 &&
              rescheduleCharges?.length <= 0 ? (
                <>
                  {!fareRulesLoading && (
                    <>
                      {(fareRule && fareRule?.length === 0) ||
                      (fareRule?.length === 1 && !fareRule[0]?.FareRuleDesc) ? (
                        <h4 className="text-center">
                          {/* No Fare Rule Found. Please contact Customer Care!!! */}
                          Non - Refundable!!!
                        </h4>
                      ) : (
                        <div className="flight-cancel flight-detail flight-table">
                          <h5 className="m-0">
                            {route?.Segments[0]?.Origin_City} {" to "}
                            {
                              route?.Segments[route?.Segments?.length - 1]
                                ?.Destination_City
                            }
                          </h5>
                          <span className="mention-tag">
                            Mentioned fees are Per Pax Per Sector <br /> Apart
                            from airline charges, GST + RAF + applicable charges
                            if any, will be charged.
                          </span>
                          <div style={{ maxHeight: 400, overflow: "auto" }}>
                            {fareRule?.map((e: any) => {
                              return (
                                <div
                                  style={{ padding: "0 10px" }}
                                  dangerouslySetInnerHTML={{
                                    __html: e?.FareRuleDesc ?? "",
                                  }}
                                />
                              );
                            })}
                          </div>
                          <span>*From the Time of Departure</span>
                          <span>*Service charge will be extra</span>
                        </div>
                      )}
                    </>
                  )}
                </>
              ) : (
                <div
                  style={{
                    maxHeight: "calc(100vh - 300px)",
                    overflowY: "auto",
                    scrollbarWidth: "thin",
                  }}
                >
                  {cancellationCharges?.length > 0 && (
                    <div className="cancel-wrapper">
                      <div className="cancel-table-container">
                        <table className="cancel-table">
                          <thead>
                            <tr>
                              <th colSpan={5} className="cancel-th">
                                <h4>Cancellation Charges</h4>
                              </th>
                            </tr>
                            <tr>
                              <th className="cancel-th">#</th>
                              <th className="cancel-th">Applicability</th>
                              <th className="cancel-th">Passenger Type</th>
                              <th className="cancel-th">Duration</th>
                              <th className="cancel-th">Charge</th>
                            </tr>
                          </thead>
                          <tbody>
                            {cancellationCharges?.map(
                              (cCharge: any, index: number) => {
                                return (
                                  <tr className="cancel-row">
                                    <td className="cancel-td">{index + 1}</td>
                                    <td className="cancel-td">
                                      <span className="cancel-pill">
                                        Per{" "}
                                        {cCharge?.Applicablility === 0
                                          ? "Segment"
                                          : "Passenger"}
                                      </span>
                                    </td>
                                    <td className="cancel-td">
                                      {cCharge?.PassengerType === 0
                                        ? "Adult"
                                        : cCharge?.PassengerType === 1
                                        ? "Child"
                                        : "Infant"}
                                    </td>
                                    <td className="cancel-td">
                                      {cCharge?.DurationFrom}{" "}
                                      {cCharge?.DurationTypeFrom === 0
                                        ? "Hr(s) "
                                        : cCharge?.DurationTypeFrom === 1
                                        ? "days "
                                        : ""}{" "}
                                      – {cCharge?.DurationTo}{" "}
                                      {cCharge?.DurationTypeTo === 0
                                        ? "Hr(s)"
                                        : cCharge?.DurationTypeTo === 1
                                        ? "days"
                                        : ""}
                                    </td>
                                    <td className="cancel-td">
                                      {+cCharge?.Value === 0 ? (
                                        "Non Chargeable"
                                      ) : +cCharge?.Value === 100 &&
                                        cCharge?.ValueType === 1 ? (
                                        "Non Refundable"
                                      ) : (
                                        <>
                                          {cCharge?.ValueType === 0 ? "₹ " : ""}
                                          {cCharge?.Value}
                                          {cCharge?.ValueType === 1 ? "%" : ""}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                            <tr className="cancel-row">
                              <td className="cancel-td" colSpan={5}>
                                <strong className="d-block">
                                  *From the Time of Departure
                                </strong>
                                <strong>*Service charge will be extra</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                  {rescheduleCharges?.length > 0 && (
                    <div className="cancel-wrapper">
                      <div className="cancel-table-container">
                        <table className="cancel-table">
                          <thead>
                            <tr>
                              <th colSpan={5} className="cancel-th">
                                <h4>Reschedule Charges</h4>
                              </th>
                            </tr>
                            <tr>
                              <th className="cancel-th">#</th>
                              <th className="cancel-th">Applicability</th>
                              <th className="cancel-th">Passenger Type</th>
                              <th className="cancel-th">Duration</th>
                              <th className="cancel-th">Charge</th>
                            </tr>
                          </thead>
                          <tbody>
                            {rescheduleCharges?.map(
                              (rCharge: any, index: number) => {
                                return (
                                  <tr className="cancel-row">
                                    <td className="cancel-td">{index + 1}</td>
                                    <td className="cancel-td">
                                      <span className="cancel-pill">
                                        Per{" "}
                                        {rCharge?.Applicablility === 0
                                          ? "Segment"
                                          : "Passenger"}
                                      </span>
                                    </td>
                                    <td className="cancel-td">
                                      {rCharge?.PassengerType === 0
                                        ? "Adult"
                                        : rCharge?.PassengerType === 1
                                        ? "Child"
                                        : "Infant"}
                                    </td>
                                    <td className="cancel-td">
                                      {rCharge?.DurationFrom}{" "}
                                      {rCharge?.DurationTypeFrom === 0
                                        ? "Hr(s) "
                                        : rCharge?.DurationTypeFrom === 1
                                        ? "days "
                                        : ""}{" "}
                                      – {rCharge?.DurationTo}{" "}
                                      {rCharge?.DurationTypeTo === 0
                                        ? "Hr(s)"
                                        : rCharge?.DurationTypeTo === 1
                                        ? "days"
                                        : ""}
                                    </td>
                                    <td className="cancel-td">
                                      {+rCharge?.Value === 0 ? (
                                        "Non Chargeable"
                                      ) : +rCharge?.Value === 100 &&
                                        rCharge?.ValueType === 1 ? (
                                        "Non Refundable"
                                      ) : (
                                        <>
                                          {rCharge?.ValueType === 0 ? "₹ " : ""}
                                          {rCharge?.Value}
                                          {rCharge?.ValueType === 1 ? "%" : ""}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                );
                              }
                            )}
                            <tr className="cancel-row">
                              <td className="cancel-td" colSpan={5}>
                                <strong className="d-block">
                                  *From the Time of Departure
                                </strong>
                                <strong>*Service charge will be extra</strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className="travel-detail-btns mt-4">
                <a
                  className="btn disable"
                  href="javascript:void(0)"
                  data-bs-dismiss="modal"
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="route-price-col">
        {sortedPriceList?.map((fare: any, index: number) => {
          let totalAdultPrice = 0;
          let totalChildPrice = 0;
          let totalInfantPrice = 0;

          fare.FareDetails.forEach((fare: any) => {
            // const totalAmount = fare.Total_Amount || 0;
            const totalAmount =
              (fare.Total_Amount || 0) - (fare.Service_Fee_Amount || 0);

            switch (fare.PAX_Type) {
              case 0:
                totalAdultPrice += totalAmount * ADULT || 0;
                break;
              case 1:
                totalChildPrice += totalAmount * CHILD || 0;
                break;
              case 2:
                totalInfantPrice += totalAmount * INFANT || 0;
                break;
              default:
                break;
            }
          });

          const totalPrice =
            totalAdultPrice + totalChildPrice + totalInfantPrice;

          const RefundableType = fare?.Refundable;

          /* CHNAGE IN RADIO BUTTON */
          return (
            <div
              className={`route-price ${
                index > 2 && !openFlightRate ? "d-none" : ""
              }`}
              key={fare?.Fare_Id}
            >
              <input
                type="radio"
                value={priceDetails}
                checked={priceDetails?.Fare_Id === fare.Fare_Id}
                name={`radio_${routeIndex}`}
                onChange={() => handleRadioButtonChange(fare?.Fare_Id)}
              />
              <label htmlFor=""></label>₹ {formatIndianNumber(totalPrice)}
              <a href="">
                {/* <span>{fare?.fareIdentifier || "DUMMY"}</span> */}
                {
                  fare?.FareDetails[0]?.FareClasses[0]?.Class_Desc
                  // .map(
                  //   (fClass: any, index: number) =>
                  //   fClass?.fClass?.Class_Code
                  //     // getNewCabinClassnameFromCode(fClass?.Class_Code)
                  //     //   ? getNewCabinClassnameFromCode(fClass?.Class_Code) +
                  //     //     `${
                  //     //       index + 1 < fare?.FareDetails[0]?.FareClasses?.length
                  //     //         ? ", "
                  //     //         : ""
                  //     //     }`
                  //     //   : ""
                  // )
                }
                {fare?.Food_onboard === "F" ? ", Free Meal" : ""}
                {RefundableType
                  ? (fare?.Food_onboard === "F" ? ", " : ", ") + "Refundable"
                  : ""}
              </a>
            </div>
          );
        })}
        {sortedPriceList?.length > 3 && (
          <div className="expand-toggle">
            <a
              className={`${openFlightRate ? "up-arrow" : "down-arrow"} `}
              onClick={() => {
                setOpenFlightRate(!openFlightRate);
              }}
            >
              <img src={ARROW_DOWN} alt="" />
            </a>
          </div>
        )}
      </div>
      {type === "multicity" ? (
        <div className="flight-btn">
          <a
            className="fill-btn"
            onClick={() =>
              handleSelectFlight &&
              handleSelectFlight(priceDetails, route, type, index || 0)
            }
          >
            {isSelected ? "Selected" : "Select"}
          </a>
        </div>
      ) : (
        <div className="flight-btn">
          <a
            className="fill-btn"
            onClick={() => handleBookNowClick(priceDetails, route)}
          >
            Book Now
          </a>
          <strong
            className="fare-rule-btn"
            data-bs-toggle="modal"
            data-bs-target={`#farerulepopup_${routeIndex}`}
            onClick={() => {
              if (
                cancellationCharges?.length <= 0 &&
                rescheduleCharges?.length <= 0
              ) {
                getFareRules(priceDetails?.Fare_Id, route?.Flight_Key);
              }
            }}
          >
            Fare Rules
          </strong>
        </div>
      )}
    </div>
  );
};

export default FlightPrice;
